import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { getCampaignsDashboard_api } from './campaignsDashboardApi';

interface CampaignsDashboard {
    [key: string]: any;
}

interface CampaignsDashboardState {
    // state
    campaignsDashboard: CampaignsDashboard[];
    isLoadingCampaignsDashboard: boolean;

    // actions
    setIsLoadingCampaignsDashboard: (isLoading: boolean) => void;

    // methods
    getCampaignsDashboard: ({ brandId, clientId, key, isAll, isAllSymphony }: { brandId?: number, clientId?: number, key?: string, isAll?: boolean, isAllSymphony?: boolean }) => Promise<void>;
}

const useCampaignsDashboard = create(immer<CampaignsDashboardState>((set) => ({
    // state
    campaignsDashboard: [],
    isLoadingCampaignsDashboard: false,

    // actions
    setIsLoadingCampaignsDashboard: (isLoading: boolean) => { set((state) => { state.isLoadingCampaignsDashboard = isLoading; }); },

    // methods
    getCampaignsDashboard: async ({ brandId, clientId, key, isAll, isAllSymphony }: { brandId?: number, clientId?: number, key?: string, isAll?: boolean, isAllSymphony?: boolean }) => {
        set({ isLoadingCampaignsDashboard: true });

        try {
            const campaignsDashboard = await getCampaignsDashboard_api({ brandId, clientId, key, isAll, isAllSymphony });
            set({ campaignsDashboard: campaignsDashboard || [] });
        } catch (error) {
            console.error(error);
        } finally {
            set({ isLoadingCampaignsDashboard: false });
        }
    }
})))

export default useCampaignsDashboard;

